"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTerritoryColumnHandler = exports.getStateColumnHandler = exports.getStateTerritoryColumnHandler = exports.getRegisterStateColumnHandler = exports.getRegionColumnHandler = exports.getGenderColumnHandler = exports.getEthnicityColumnHandler = exports.getCountyColumnHandler = void 0;
const mapAdvancedSearchOpToStringColumnFilter_1 = require("../../advanced-search/utils/mapAdvancedSearchOpToStringColumnFilter");
const getColumnsHandlerTypeId_1 = require("./getColumnsHandlerTypeId");
const getColumnsHandlerTypeString_1 = require("./getColumnsHandlerTypeString");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getCountyColumnHandler(countyValueProvider, params = {}) {
    return (0, getColumnsHandlerTypeString_1.getColumnsHandlerTypeString)(countyValueProvider, params, {
        subFilterEntity: 'jurisdiction',
        subFilterColumn: 'name',
        onGetStorageSubFilter: (operator, value) => ({
            op: 'and',
            filter: [{ column: 'type', op: '=', value: 'county' }, (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value)],
        }),
    });
}
exports.getCountyColumnHandler = getCountyColumnHandler;
function getEthnicityColumnHandler(ethnicityValueProvider) {
    return (0, getColumnsHandlerTypeId_1.getColumnsHandlerTypeId)(ethnicityValueProvider, {
        subFilterEntity: 'ethnicity',
        onGetStorageSubFilter: (operator, value) => (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value),
    });
}
exports.getEthnicityColumnHandler = getEthnicityColumnHandler;
function getGenderColumnHandler(genderValueProvider) {
    return (0, getColumnsHandlerTypeId_1.getColumnsHandlerTypeId)(genderValueProvider, {
        subFilterEntity: 'gender',
        onGetStorageSubFilter: (operator, value) => (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value),
    });
}
exports.getGenderColumnHandler = getGenderColumnHandler;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getRegionColumnHandler(regionValueProvider, params = {}) {
    return (0, getColumnsHandlerTypeString_1.getColumnsHandlerTypeString)(regionValueProvider, params, {
        subFilterEntity: 'region',
        subFilterColumn: 'name',
        onGetStorageSubFilter: (operator, value) => (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value),
    });
}
exports.getRegionColumnHandler = getRegionColumnHandler;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getRegisterStateColumnHandler(registerStateValueProvider, params = {}) {
    return (0, getColumnsHandlerTypeString_1.getColumnsHandlerTypeString)(registerStateValueProvider, params, {
        subFilterEntity: 'jurisdiction',
        subFilterColumn: 'postalCode',
        onGetStorageSubFilter: (operator, value) => ({
            op: 'and',
            filter: [{ column: 'type', op: '=', value: 'state' }, (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value)],
        }),
    });
}
exports.getRegisterStateColumnHandler = getRegisterStateColumnHandler;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getStateTerritoryColumnHandler(stateTerritoryValueProvider, params = {}) {
    return (0, getColumnsHandlerTypeString_1.getColumnsHandlerTypeString)(stateTerritoryValueProvider, params, {
        subFilterEntity: 'jurisdiction',
        subFilterColumn: 'postalCode',
        onGetStorageSubFilter: (operator, value) => ({
            op: 'and',
            filter: [
                { column: 'type', op: 'in', value: ['state', 'territory'] },
                (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value),
            ],
        }),
    });
}
exports.getStateTerritoryColumnHandler = getStateTerritoryColumnHandler;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getStateColumnHandler(stateValueProvider, params = {}) {
    return (0, getColumnsHandlerTypeString_1.getColumnsHandlerTypeString)(stateValueProvider, params, {
        subFilterEntity: 'jurisdiction',
        subFilterColumn: 'postalCode',
        onGetStorageSubFilter: (operator, value) => ({
            op: 'and',
            filter: [{ column: 'type', op: '=', value: 'state' }, (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value)],
        }),
    });
}
exports.getStateColumnHandler = getStateColumnHandler;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getTerritoryColumnHandler(territoryValueProvider, params = {}) {
    return (0, getColumnsHandlerTypeString_1.getColumnsHandlerTypeString)(territoryValueProvider, params, {
        subFilterEntity: 'jurisdiction',
        subFilterColumn: 'postalCode',
        onGetStorageSubFilter: (operator, value) => ({
            op: 'and',
            filter: [{ column: 'type', op: '=', value: 'territory' }, (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value)],
        }),
    });
}
exports.getTerritoryColumnHandler = getTerritoryColumnHandler;
